import { Controller } from "@hotwired/stimulus"

// Keeps the "Email" and "Incl PDF" checkboxes consistent:
//   - syncPdf:  checking PDF forces Email checked (a PDF attachment is
//     meaningless without the email being sent).
//   - syncEmail: unchecking Email forces PDF unchecked (don't request a PDF
//     attachment when there's no email to send it with).
// Wired on both the profile-defaults form and the realtime order
// thank-you card.
export default class extends Controller {
  static targets = ["pdf", "email"]

  syncPdf() {
    if (!this.hasPdfTarget || !this.hasEmailTarget) return
    if (this.pdfTarget.checked) this.emailTarget.checked = true
  }

  syncEmail() {
    if (!this.hasPdfTarget || !this.hasEmailTarget) return
    if (!this.emailTarget.checked) this.pdfTarget.checked = false
  }
}
